import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { Formik, Form, Field } from 'formik'
import api from "../../services/api";
import * as Yup from 'yup';
import { Toast } from '../../shared/Toast'
import Paginator from '../../shared/Paginator';
import config from '../../config'
import { debounce } from '../../utils/Debounce';
import TableLoader from '../../shared/TableLoader';
import NoDataFound from '../../shared/NoDataFound';
import { roles } from '../../utils/constants';
import { SlButton, SlInput, SlIcon, SlDrawer } from '@shoelace-style/shoelace/dist/react';
import { useDispatch, useSelector } from 'react-redux';

const campaignschema = Yup.object().shape({
  name: Yup.string().required('Campaign Category Name is required').matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Name can't start with white space and should not contain special characters")
})

function CampaignCategories() {
  const navigate = useNavigate()
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("")
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loader, setLoader] = useState(false);
  const HeaderSearch = useSelector(state => state.Head.adssearch)


  useEffect(() => {
    const role = localStorage.getItem("role")

    if (role !== roles.ops)
      navigate("/pagenotfound")
    getData(search, currentPage);
  }, [search, currentPage])


  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     getData()
  //   }, 200);

  //   return () => clearTimeout(timer);
  // }, [search]);

  const formatDateWithTime = (date) => {
    return new Date(date * 1000).toLocaleDateString('en-US', {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: '2-digit',
      minute: '2-digit'
    })
  }


  const getData = async (searchString = '', page = 0) => {
    try {
      setLoader(true)
      let res = await api({
        url: `/user/campaign/get`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: searchString
        }
      });
      setData(res.data.data)
      setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
      setLoader(false)
    } catch (error) {
      setLoader(false)
      console.error("error occurred", error)
    }


  }

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
  }


  const postData = async (value) => {
    try {
      let res = await api({
        url: `/user/campaign`,
        method: "POST",
        responseType: "json",
        data: {
          value,
        }
      });
      if (res.code === 200) {
        setShow(false)
        Toast('success', 'Created Succesfully')
        setCurrentPage(0);
        setSearch('');
        getData(search, currentPage)
      }
      else {
        Toast("error", "Name Already Exist")
      }
    } catch (error) {
      if (error.response.status === 401)
        navigate("/")
    }


  }

  const checkstatus = async (val, status) => {
    try {
      let res = await api({
        url: `/user/campaign/status`,
        method: "POST",
        responseType: "json",
        data: { val, status }
      });
      if (res.code === 200) {
        Toast('success', 'Changed Succesfully')
        getData(search, currentPage)
      }
      else {
        console.error("Updation Failed")
      }
    } catch (error) {
      let er = error?.response?.message || "Something went wrong"
      Toast("error", er)
      if (error.response.status === 401)
        navigate("/")
    }
  }


  const handlePageClick = (event) => {
    // const newOffset = (event.selected * config.PER_PAGE) % data.length;
    // setItemOffset(newOffset);
    setCurrentPage(event.selected);
  };

  const searchData = e => {
    setSearch(e.target.value);
    setCurrentPage(0);
  }

  return (
    <>
      <header class="flex items-center mb-3 flex-wrap">
        <h5>Campaigns Categories</h5>
        <aside class="flex items-center gap-3 ml-auto">
          <div>
            <SlInput size='small' id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Category Name..">
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
          </div>
          <SlButton size="small" variant="primary" onClick={handleShow}>Add Category</SlButton>
        </aside>
      </header>
      <div className="mb-4">
        <table className="table table-bordered">
          <thead className="sticky top-0">
            <tr>
              {/* <th scope="col">Category Id</th> */}
              <th>Category Name</th>
              <th>Created Date</th>
              <th>Status</th>
            </tr>
          </thead>
          {(data?.length && !loader) ? (<tbody>
            {data?.map((item) => {
              return (
                <tr key={item.category_id} className="group/details hover:bg-slate-100">
                  {/* <td>{item.category_id}</td> */}
                  <td>{item.category_name}</td>
                  <td>{formatDateWithTime(item.created_date)}</td>
                  <td>
                    <div className="form-check form-switch" style={{ marginLeft: '2rem' }}>
                      <input className="form-check-input" type="checkbox" role="switch" checked={item.status} onChange={(e) => { checkstatus(item.category_id, item.status) }} />
                    </div>
                  </td>

                </tr>
              )
            })}
          </tbody>) : ((!data?.length && !loader) ? <NoDataFound colspan="4" /> : <TableLoader colspan="4" />)
          }
        </table>
      </div>
      <div className='flex justify-end'>
        {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}
      </div>
      <SlDrawer label="Campaign Category" open={show} onSlAfterHide={() => setShow(false)} style={{ '--size': `${window.innerWidth <= 767 ? '100vw' : '20vw' }`}}>
        {/* <Modal.Header closeButton>
          <Modal.Title>Campaign Category</Modal.Title>
        </Modal.Header>
        <Modal.Body> */}

        <Formik
          initialValues={{ name: "" }}
          validationSchema={campaignschema}
          onSubmit={async (values) => {
            postData(values.name)
          }}
        >
          {({ errors, touched }) => (
            <Form>
              <div className='mb-3'>
                <Field name="name" type="text" placeholder='Enter Category name' className="form-control" />
                {errors.name && touched.name && <div style={{ color: 'red' }}>{errors.name}</div>}
              </div>
              <SlButton variant="primary" type='submit'>Submit</SlButton>
            </Form>
          )}
        </Formik>
        {/* </Modal.Body>
        <Modal.Footer>
        </Modal.Footer> */}
      </SlDrawer>
    </>
  )


}
export default CampaignCategories
